import {
  ChallengeShell,
  ChoiceGrid,
  useChoices,
  usePickHandler,
  type ChallengeProps,
} from "./shared";

/** Listen to the English word, pick the matching written English word. */
export function AudioToEnglish({ word, distractors, onAnswer }: ChallengeProps) {
  const choices = useChoices(word, distractors);
  const { picked, handle, teachOverlay } = usePickHandler(word, onAnswer);

  return (
    <>
      <ChallengeShell
        tag="Listen"
        prompt="Listen and pick the word you hear"
        speakerText={word.english}
        speakerAudioUrl={word.audioUrl}
      >
        <ChoiceGrid
          choices={choices}
          correctId={word.id}
          picked={picked}
          onPick={handle}
          render={(c) => <span className="choice-vi">{c.english}</span>}
        />
      </ChallengeShell>
      {teachOverlay}
    </>
  );
}
